
/**
 * @fileOverview ListToSelect module definition 
 Last Modified 02/12/15
 */


(function (context) {
    'use strict';
    var require = context.require;
    var requirejs = context.requirejs;
    var define = context.define;

    define('views/ListToSelectList',['require','jquery','lib/Util','GlobalEventDispatcher','GlobalResizeListener'],function(require) {
        var $ = require('jquery');
        var Util = require('lib/Util');
        var GlobalEventDispatcher = require('GlobalEventDispatcher');
        var GlobalResizeListener = require('GlobalResizeListener');
        $debug('ListToSelect loaded... use ?debug=listToSelect for messages');

        /**
         * This takes a list of links and converts it to a select element on the smallest view. It converts
         * back on transition to a larger view.
         *
         * @class ListToSelect
         * @param {jQuery} $element A reference to the containing DOM element
         * @constructor
         */
        var ListToSelect = function ($element) {
            /**
             * A reference to the containing DOM element
             *
             * @default null
             * @property $element
             * @type {jQuery}
             * @public
             */
            this.$element = $($element);
            /**
             * A reference to the global event dispatcher, provided by the application.
             *
             * @property eventDispatcher
             * @type {}
             * @private
             */
            this.eventDispatcher = GlobalEventDispatcher.getEventDispatcher(); // event dispatcher that will call the event, provided by the application

            /**
             * A reference to the global resize listener.
             *
             * @property getResizeListener
             * @type {}
             * @private
             */
            this.globalResizeListener = GlobalResizeListener.getResizeListener();

            /**
             * Tracks whether component is enabled.
             *
             * @default false
             * @property isEnabled
             * @type {bool}
             * @public
             */
            this.isEnabled = false;

            this.init();
        };

        /**
         * Initializes the UI Component View
         * Runs a single setupHandlers call, followed by createChildren and layout
         * Exits early if it is already initialized
         *
         * @method init
         * @returns {ListToSelect}
         * @private
         */
        ListToSelect.prototype.init = function() {
            this.setOptions()
                .setupHandlers()
                .createChildren()
                .layout();

            return this;
        };

        /**
         * Binds the scope of any handler functions
         * Should only be run on initialization of the view
         *
         * This creates event handlers and binds the scope
         * of the JS.
         *
         * @method setupHandlers
         * @returns {ListToSelect}
         * @private
         */
        ListToSelect.prototype.setupHandlers = function() {
            // Bind event handlers scope here
            this.eventDispatcher.subscribe(GlobalEventDispatcher.EVENTS.CONTEXT_CHANGE, this.layout.bind(this));            
            this.onChangeHandler = this.onChange.bind(this);

            return this;
        };
 /**
         * This sets the options via data-options in the html markup. If
         * the options aren't set it goes to the defaults.
         * Syntax for HTML should be data-options='{"exampleOption" : "bar", "enabled" : false, "xLength" : 45, "option2" : "foo"}'
         *
         * @method setOptions
         * @returns {ListToSelect}
         * @private
         */
        ListToSelect.prototype.setOptions = function () {
            var options = this.$element.data().options;
            var defaults = {
                
            };

            this.settings = $.extend({}, defaults, options);    //merge defaults with data-options object
            $debug('     ListToSelect Options ', 'listToSelect');
            $debug('          HTML data-options Settings: ' + $printObj(options),'listToSelect');
            $debug('          Default Settings: ' + $printObj(defaults),'listToSelect');
            $debug('          Combined Settings: ' + $printObj(this.settings),'listToSelect');
            return this;
        };

        /**
         * Create any child objects or references to DOM elements
         * Should only be run on initialization of the view
         *
         * @method createChildren
         * @returns {ListToSelect}
         * @private
         */
        ListToSelect.prototype.createChildren = function() {
            this.$menuList = this.$element.children('.js-menuList-list');
            this.$selectMenu = null;
            return this;
        };

        /**
         * Remove any child objects or references to DOM elements
         *
         * @method removeChildren
         * @returns {ListToSelect}
         * @public
         */
        ListToSelect.prototype.removeChildren = function() {

            return this;
        };

        /**
         * Performs measurements and applys any positioning style logic
         * Should be run anytime the parent layout changes
         *
         * @method layout
         * @returns {ListToSelect}
         * @public
         */
        ListToSelect.prototype.layout = function() {
            var self = this;
            var context = this.globalResizeListener.getCurrentContext();
            $debug('Layout Change Fired ' + context, 'listToSelect');            
            if (context === 'smallContext') {
                if(self.$selectMenu === null) {                
                    self.$element.append('<select class="js-menuList-select" />');
                    self.$selectMenu = self.$element.children('.js-menuList-select');
                    if(self.settings.firstSelectOption){
                        self.$selectMenu.append('<option val="">' + self.settings.firstSelectOption + '</option>');
                    }
                    
                    for(var i = 0; i < self.$menuList.length; i++){
                        self.$menuList.eq(i).find('a').each(function() {
                            var el = $(this);
                            var href = el.prop('href');
                            this.$firstSlash = href.indexOf('/');
                            this.$http = href.indexOf('https://');
                            this.$https = href.indexOf('https://');
                            if (this.$firstSlash !== -1 && href.indexOf('/', this.$firstSlash + 1) !== -1  || this.$http !== -1 || this.$https !== -1) {
                                $debug('Checked for first / and assumed to be a URL! Sending you there now... Good Bye', 'listToSelect');
                                href = href;
                            } else if (href.indexOf('#') === -1 && this.$firstSlash === -1 || href.indexOf('https://') === -1 || href.indexOf('https://') === -1){
                                href = '#' + href;
                            }
                            
                            $('<option />', {
                                'value' : href,
                                'text' : el.text()
                            }).appendTo(self.$selectMenu.eq(i));
                            if (el.hasClass('MMM--isActive')){

                                self.$selectMenu.children('option:last').prop('Selected',true);
                                $debug('Found MMM--isActive class ', 'listToSelect');
                            }
                            //set the rest of the values to false for safari
                            else{

                                self.$selectMenu.children('option:last').prop('Selected',false);
                                $debug('Found MMM--isActive class ', 'listToSelect');
                            }
                        });
                    }
                    self.enable();
                    self.$menuList.hide();
                }
                
                return self.$selectMenu;
            } else {
                if(self.$selectMenu !== null) {
                    self.disable();
                    self.$selectMenu.remove();
                    self.$selectMenu = null;
                }
                self.$menuList.show();
            }

            return this;
        };

        /**
         * Enables the component
         * Performs any event binding to handlers
         * Exits early if it is already enabled
         *
         * @method enable
         * @returns {ListToSelect}
         * @public
         */
        ListToSelect.prototype.enable = function() {
            
            if (this.isEnabled) {
                return this;
            }
            this.isEnabled = true;
            this.$selectMenu.on('change', this.onChangeHandler);

            return this;
        };

        /**
         * Disables the component
         * Tears down any event binding to handlers
         * Exits early if it is already disabled
         *
         * @method disable
         * @returns {ListToSelect}
         * @public
         */
        ListToSelect.prototype.disable = function() {            
            if (!this.isEnabled) {
                return this;
            }
            this.isEnabled = false;
            this.$selectMenu.off('change', this.onChangeHandler);

            return this;
        };

        /**
         * Destroys the component
         * Tears down any events, handlers, elements
         * Should be called when the object should be left unused
         *
         * @method destroy
         * @returns {ListToSelect}
         * @public
         */
        ListToSelect.prototype.destroy = function() {
            this.disable()
                .removeChildren();
            return this;
        };

        //////////////////////////////////////////////////////////////////////////////////
        // EVENT HANDLERS
        //
        // Place events here, use event handlers to access it
        //////////////////////////////////////////////////////////////////////////////////

        /**
         * onChange handler
         * When the select is changed it fires an alert of the selected value.
         *
         * @method onChange
         * @private
         */
        ListToSelect.prototype.onChange = function() {
            
            var currentSelect = document.activeElement;
            var value = currentSelect.value;
            $debug('List item selected... value is: ' + value, 'listToSelect');               
            if (value !== ''){
                $debug('Checking to see if URL', 'listToSelect');
                //check to see if value is a URL
                this.$firstSlash = value.indexOf('/');
                this.$http = value.indexOf('https://');
                this.$https = value.indexOf('https://');

                if (this.$firstSlash !== -1 && value.indexOf('/', this.$firstSlash + 1) !== -1 || this.$http !== -1 || this.$https !== -1) {
                    $debug('   Assumed to be a URL! Sending you there now... Good Bye', 'listToSelect');
                    location.href = value;
                }
                //add additional validations here... 
                else if (value.substring(0,1) === '#') {
                    $debug('   Assumed to be an href with # tag, taking you there now', 'listToSelect');
                    location.href = value.substring(1);
                }            else {
                    $debug('   No known conditions were met... contact T&C team to enhance module');
                    
                }
            }

        };
        return ListToSelect;
    });

}(MMMRequire));

